import ExpenseDetails from "../../Components/Expenses/ExpenseDetails";
import "../../Components/Style/Expenses/ExpenseShow.css"


function ExpenseShow() {
  return (
    <div className="expense-show-page">
      <ExpenseDetails />
    </div>
  );
}

export default ExpenseShow;
